import React from 'react';
import { motion } from 'framer-motion';
const BONUSES = [{
  num: '01',
  title: 'Checklist de Aplicación Perfecta',
  desc: 'No te olvidás de nada en tu primer trabajo. Revisalo antes de cada proyecto.',
  value: '$15.000'
}, {
  num: '02',
  title: 'Primeros Clientes en 7 Días',
  desc: 'El plan exacto de qué hacer para conseguir trabajo en la primera semana.',
  value: '$25.000'
}, {
  num: '03',
  title: 'Guía de Precios Real (Argentina)',
  desc: 'Precios de mercado actualizados para que nunca cobres de menos.',
  value: '$18.000'
}, {
  num: '04',
  title: 'Errores que Hacen Perder Plata',
  desc: 'Los errores clásicos de principiante que arruinan trabajos y reputación.',
  value: '$12.000'
}, {
  num: '05',
  title: 'Scripts de Venta Listos',
  desc: 'Qué decir palabra por palabra para cerrar clientes sin presionar.',
  value: '$15.000'
}, {
  num: '06',
  title: 'Proyectos de Alto Valor',
  desc: 'Cómo identificar y cotizar los trabajos que pagan 3 a 5 veces más por hora.',
  value: '$25.000'
}];
export function Bonuses() {
  return <section className="py-12 md:py-16 px-4 bg-black border-t border-white/5" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-42">
          <span className="inline-block bg-brand-yellow text-black font-bold text-xs md:text-sm tracking-widest uppercase px-4 py-2 rounded-full mb-6" data-id="element-43">
            Bonus Exclusivos Incluidos
          </span>
          <h2 className="text-4xl md:text-6xl text-white leading-[1.05]" data-id="element-44">
            6 EXTRAS QUE SOLOS{' '}
            <span className="text-brand-yellow" data-id="element-45">YA JUSTIFICAN EL PRECIO.</span>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-4 md:gap-5" data-id="element-46">
          {BONUSES.map((bonus, i) => <motion.div key={bonus.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="relative overflow-hidden bg-black border border-brand-gold/30 rounded-2xl p-6 md:p-8" data-id="element-47">
              {/* Giant faint number */}
              <span aria-hidden="true" className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 font-display text-white/[0.04] text-[6rem] md:text-[9rem] leading-none select-none" data-id="element-48">
                {bonus.num}
              </span>

              <div className="relative z-10 pr-16 md:pr-24" data-id="element-49">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3 normal-case tracking-normal" data-id="element-50">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 font-medium leading-relaxed mb-4" data-id="element-51">
                  {bonus.desc}
                </p>
                <p className="text-lg font-bold" data-id="element-52">
                  <span className="text-gray-500 line-through" data-id="element-53">
                    {bonus.value}
                  </span>
                  <span className="text-brand-yellow ml-3 uppercase text-sm tracking-wider" data-id="element-54">
                    Incluido gratis
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}